<template>
  <section class="app-container">
    <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="params.pickerTime" @change="handleTimeChange" :options="params.pickerTimeOptions" />
    </van-dropdown-menu>
    <component :is="currentList" :orders="orders"></component>
  </section>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant'
import { deepClone, parseTime } from '@/utils'
import { mapGetters } from 'vuex'
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import config from '@/config/index'
import { getBillingHistory } from '@/api/park'
export default {
  name: 'Invoice-Temporary',
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'wx_token', 'token'])
  },
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    Available,
    Unavailable
  },
  data () {
    return {
      currentList: 'Unavailable',
      orders: [],
      config,
      listQuery: {
        //过滤参数
        page: 1,
        limit: 9999999,
      },
      params: {
        pickerTime: 1,
        pickerOrder: 0,
        parkId: 0,
        outTradeNo: null,
        pickerTimeOptions: [
          { text: '今天', value: 1 },
          { text: '最近一周', value: 7 },
          { text: '最近半年', value: 180 },
          { text: '最近三个月', value: 90 }
        ],
        pickerOrderOptions: [],
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString('zh')).getTime()
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString('zh')).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
    }
  },
  mounted () {
    this.componentsValve()
  },
  methods: {
    // 时间选项改变
    handleTimeChange (val) {
      this.params.startDate[0] = parseTime(new Date(new Date(new Date().toLocaleDateString('zh')).getTime() - val * 24 * 60 * 60 * 1000))
      this.componentsValve()
    },
    // 查询数据
    componentsValve () {
      let _this = this
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      let params = {
        startTime: _this.params.startDate[0],
        endTime: _this.params.startDate[1],
        startPage: _this.listQuery.page,
        pageSize: _this.listQuery.limit,
      }
      getBillingHistory(params).then(res => {
        let data = res.body
        data.forEach(element => {
          // if (typeof element.paidMoney === 'number') {
          //   element.priceArr = element.paidMoney.toFixed(2).split('.')
          // }
          // else {
          //   element.paidMoney = element.paidMoney.slice(0, element.paidMoney.length - 2) + '.' + element.paidMoney.slice(element.paidMoney.length - 2)
          //   element.priceArr = (element.paidMoney - 0).toFixed(2).split('.')
          // }
        });
        _this.getInfo_Loading.clear()
        if (data.length > 0) {
          _this.orders = deepClone(data)
          _this.currentList = 'Available'
        } else {
          _this.currentList = 'Unavailable'
        }
      }).catch(err => {
        _this.getInfo_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: err
        })
      })

    },
  }
}
</script>

<style lang="scss" scoped></style>
